import { Amplify } from 'aws-amplify';
import { I18n } from 'aws-amplify/utils';

// Pulled from Vite env vars at build time (set per environment in CI/CD).
// Local dev: copy .env.example to .env.local and fill in dev pool ids.
const userPoolId = import.meta.env.VITE_COGNITO_USER_POOL_ID ?? '';
const userPoolClientId = import.meta.env.VITE_COGNITO_USER_POOL_CLIENT_ID ?? '';

if (!userPoolId || !userPoolClientId) {
  // eslint-disable-next-line no-console
  console.warn(
    'VITE_COGNITO_USER_POOL_ID / VITE_COGNITO_USER_POOL_CLIENT_ID are not set. Auth will not work.',
  );
}

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId,
      userPoolClientId,
    },
  },
});

// Cognito uses "username" internally as the primary identifier, but our user
// pool is configured email-as-username — so the default Amplify Authenticator
// labels read "Username" everywhere, which is misleading. These overrides
// rename the visible label + placeholder strings to "Email" across every
// Authenticator screen (sign in, sign up, forgot password, confirm).
I18n.putVocabulariesForLanguage('en', {
  Username: 'Email',
  'Enter your Username': 'Enter your email address',
  'Enter your username': 'Enter your email address',
  'Please confirm your Password': 'Confirm your password',
});

